import React from 'react';
import css from './LogBook.module.scss'
import check from '../../../images/check.svg'
import refresh from "../../../images/refresh.svg";
import {defaultColumns, filters} from "../../../redux/types";
import {useTheme} from "../../../App";
import {useTranslation} from "react-i18next";

const EditTable = ({selectedFilters, setSelectedFilters, isDark}) => {
  const {t} = useTranslation()
  return (
    <div className={`${css.checkboxes} ${isDark && css.checkboxes__dark}`}>
      {filters.map((filter, index) => <CustomCheckBox isDark={isDark} key={index} onClick={() => {
        if (selectedFilters.find(s => s.name === filter.name)) {
          setSelectedFilters([...selectedFilters].filter(f => f.name !== filter.name))
        } else {
          setSelectedFilters([...selectedFilters, {...filter}])
        }
      }} caption={t(filter.label)} isChecked={selectedFilters.find(s => s.name === filter.name)}/>)}
      <button onClick={() => setSelectedFilters([...defaultColumns])} className={`${css.filterThrow} mb-20`}>
        <img src={refresh} alt="" className={css.filterThrow__icon}/>
        Сбросить настройки таблицы
      </button>
    </div>
  );
};

export default React.memo(EditTable);

export const CustomCheckBox = ({isChecked, caption, onClick, color, fontFamily, marginBottom, isDark, ...props}) => {
  return <div {...props} style={marginBottom && {marginBottom}} className={`${css.checkWrapper} ${isDark && css.checkWrapper__dark}`}>
    <button onClick={onClick} className={`${isChecked ? css.checkbox__selected : css.checkbox}`}>
      {isChecked && <img src={check} alt=""/>}
    </button>
    {caption && <p style={(color && fontFamily) && {color, fontFamily}} className={css.checkText}>
      {caption}
    </p>}
  </div>
}
